import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import "../node_modules/@fortawesome/fontawesome-free/css/all.min.css";
import "../node_modules/@fortawesome/fontawesome-free/css/fontawesome.min.css";
import "../node_modules/@tabler/icons-webfont/dist/tabler-icons.css";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js";

import "../src/style/css/iconsax.css";
import store, {persistor} from "./core/redux/store";
import ALLRoutes from "./feature-module/router/router";
import "./index.scss";
import {PersistGate} from "redux-persist/integration/react";

import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./core/helpers/microsoftConfig";

// Remove any previously persisted Redux state
try {
  localStorage.removeItem('persist:root');
} catch (e) {
  // ignore
}

const msalInstance = new PublicClientApplication(msalConfig);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
    <MsalProvider instance={msalInstance}>
        <Provider store={store}>
            <PersistGate persistor={persistor}>
                <BrowserRouter basename={"/"}>
                    <ALLRoutes />
                </BrowserRouter>
            </PersistGate>
        </Provider>
    </MsalProvider>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
